/*
 * @Author: lisanmei
 * @Date: 2022-02-14 14:47:00
 * @LastEditTime: 2022-02-14 14:47:00
 * @LastEditors: lisanmei
 * @Description: 投保人证件附件上传
 */
import React from 'react';
import { cloneDeep } from 'lodash';
import FormItem from '@/baseComponents/FormItem';
import CertAttachmentUpload from '@/components/CertAttachmentUpload';
import { useStore } from '@/store';
import { CERT_TYPE_LIST } from '@/constants';
import './index.less';

const validator = async (arr, type) => {
  if (!arr || type === 'I' && arr.filter(item => !!item).length < 2) {
    return Promise.reject(new Error('请上传'));
  }
};

const HolderContent = () => {
  var _CERT_TYPE_LIST$find;

  const {
    holder
  } = useStore('orderDetail') || {};
  const {
    person = {}
  } = holder || {};
  const {
    certType,
    name
  } = person || {};
  const certName = ((_CERT_TYPE_LIST$find = CERT_TYPE_LIST.find(item => item.short === certType)) === null || _CERT_TYPE_LIST$find === void 0 ? void 0 : _CERT_TYPE_LIST$find.name) || '';
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "header"
  }, /*#__PURE__*/React.createElement("div", null, "\u6295\u4FDD\u4EBA\uFF1A", name), /*#__PURE__*/React.createElement("div", null, "\u8BC1\u4EF6\u7C7B\u578B\uFF1A", certName)), /*#__PURE__*/React.createElement(FormItem, {
    name: "holder.certAttachment",
    fieldOption: {
      rules: [{
        validator: (_, arr) => validator(arr, certType)
      }]
    }
  }, /*#__PURE__*/React.createElement(CertAttachmentUpload, {
    isIDCard: certType === 'I'
  })));
};

const InsurantContent = () => {
  const {
    insuredList = [{
      person: {}
    }]
  } = useStore('orderDetail') || {};

  const _insuredList = cloneDeep(insuredList);

  return _insuredList.map((insured, index) => {
    var _CERT_TYPE_LIST$find2;

    const {
      person: {
        name,
        certType
      }
    } = insured;
    const certName = ((_CERT_TYPE_LIST$find2 = CERT_TYPE_LIST.find(item => item.short === certType)) === null || _CERT_TYPE_LIST$find2 === void 0 ? void 0 : _CERT_TYPE_LIST$find2.name) || '';
    return /*#__PURE__*/React.createElement("div", {
      key: index
    }, /*#__PURE__*/React.createElement("div", {
      className: "header"
    }, /*#__PURE__*/React.createElement("div", null, "\u88AB\u4FDD\u9669\u4EBA\uFF1A", name), /*#__PURE__*/React.createElement("div", null, "\u8BC1\u4EF6\u7C7B\u578B\uFF1A", certName)), /*#__PURE__*/React.createElement(FormItem, {
      name: `insured[${index}].certAttachment`,
      fieldOption: {
        rules: [{
          validator: (_, arr) => validator(arr, certType)
        }]
      }
    }, /*#__PURE__*/React.createElement(CertAttachmentUpload, {
      isIDCard: certType === 'I'
    })));
  });
};

const BeneficiaryContent = () => {
  const {
    insuredList = [{
      person: {},
      beneficiaryList: [{
        person: {}
      }]
    }]
  } = useStore('orderDetail') || {};

  const _insuredList = cloneDeep(insuredList);

  return _insuredList.map((insured, index) => {
    const {
      person: insuredPerson,
      beneficiaryList
    } = insured;
    return beneficiaryList.map((beneficiary, _index) => {
      var _CERT_TYPE_LIST$find3;

      const {
        person: {
          name,
          certType
        }
      } = beneficiary;
      const certName = ((_CERT_TYPE_LIST$find3 = CERT_TYPE_LIST.find(item => item.short === certType)) === null || _CERT_TYPE_LIST$find3 === void 0 ? void 0 : _CERT_TYPE_LIST$find3.name) || '';
      return /*#__PURE__*/React.createElement("div", {
        key: `beneficiary_${index}_${_index}`
      }, /*#__PURE__*/React.createElement("div", {
        className: "header"
      }, /*#__PURE__*/React.createElement("div", null, "\u53D7\u76CA\u4EBA\uFF1A", name), /*#__PURE__*/React.createElement("div", {
        className: "insurer-item"
      }, "\u88AB\u4FDD\u9669\u4EBA\uFF1A", insuredPerson.name), /*#__PURE__*/React.createElement("div", null, "\u8BC1\u4EF6\u7C7B\u578B\uFF1A", certName)), /*#__PURE__*/React.createElement(FormItem, {
        name: `beneficiary[${index}][${_index}].certAttachment`,
        fieldOption: {
          rules: [{
            validator: (_, arr) => validator(arr, certType)
          }]
        }
      }, /*#__PURE__*/React.createElement(CertAttachmentUpload, {
        isIDCard: certType === 'I'
      })));
    });
  });
};

const CertImage = props => {
  const {
    type
  } = props;
  let content = null;

  switch (type) {
    case '0':
      content = /*#__PURE__*/React.createElement(HolderContent, null);
      break;

    case '1':
      content = /*#__PURE__*/React.createElement(InsurantContent, null);
      break;

    case '2':
      content = /*#__PURE__*/React.createElement(BeneficiaryContent, null);
      break;
  }

  return /*#__PURE__*/React.createElement("div", {
    className: "components-holder-cert-image"
  }, content);
};

export default CertImage;